import axios, { AxiosResponse } from 'axios';
import { ApiResponse, GetReportResponse, zps_ms_ea_war } from '../../zps';
import { handleDownload } from '../../../app/utils/script';
import { IEntityLabel } from '../../equipment';

export interface IHelpdeskEquipment {
  agreeId?: number;
  agreeState?: number;
  eid: number;
  entity?: IEntityLabel;
  gid: number;
  initAccepted?: boolean;
  licenceExp?: string;
  maintEntity?: IEntityLabel;
  maintEntity2?: IEntityLabel;
  posid?: number;
  productCode?: string;
  sid?: number;
  sidDescription?: string;
  sn: string;
  softwareVersion?: string;
  status?: string;
  type: number;
  tb520: any;
  maxCurrencies?: number;
  lastCommDate?: string;
}

export interface IHelpdeskEquipmentResponse extends ApiResponse {
  list: IHelpdeskEquipment[];
  totalRows: number;
  type: string;
}

export interface EquipmentRegistrationRequest {
  eid: number;
  entid: number;
  maintid?: number;
  maintid2?: number;
  dateTimeExp: string;
  shop: { sid: number; name: string };
  posid?: number;
  maxCurrencies?: number;
}

export interface EquipmentAutorizeInitializationRequest {
  eid: number;
  initAccepted: boolean;
}

export const fetchHelpdeskEquipmentList = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  entid: number,
  etid?: number,
  sn?: string,
  eid?: number
): Promise<AxiosResponse<IHelpdeskEquipmentResponse>> => {
  const url =
    `${zps_ms_ea_war}/equipment?` +
    (entid ? `&entid=${entid}` : '') +
    (etid ? `&etid=${etid}` : '') +
    (sn ? `&sn=${sn}` : '') +
    (eid ? `&eid=${eid}` : '') +
    `&offset=${offset}&limit=${limit}&totalRows=${totalRows}`;

  return axios.get<IHelpdeskEquipmentResponse>(url, { signal: controller.signal });
};

export const fetchHelpdeskEquipInfo = (
  eid: number,
  controller: AbortController
): Promise<AxiosResponse<IHelpdeskEquipmentResponse>> => {
  return axios.get<IHelpdeskEquipmentResponse>(`${zps_ms_ea_war}/equipment?&eid=${eid}`, { signal: controller.signal });
};

export const updateHelpdeskEquipment = (
  request: EquipmentRegistrationRequest,
  controller: AbortController
): Promise<AxiosResponse<IHelpdeskEquipmentResponse>> => {
  return axios.post<IHelpdeskEquipmentResponse>(`${zps_ms_ea_war}/equipment/registration`, request, {
    signal: controller.signal
  });
};

export const IntializationHelpdeskEquipment = (
  request: EquipmentAutorizeInitializationRequest,
  controller: AbortController
): Promise<AxiosResponse<IHelpdeskEquipmentResponse>> => {
  return axios.put<IHelpdeskEquipmentResponse>(`${zps_ms_ea_war}/equipment/init`, request, {
    signal: controller.signal
  });
};

export const fetchExistencesMSReport = (
  controller: AbortController,
  entid: number,
  etid?: number,
  sn?: string,
  eid?: number
): Promise<AxiosResponse<GetReportResponse>> => {
  const url =
    `${zps_ms_ea_war}/equipment/report?format=xls` +
    (entid ? `&entid=${entid}` : '') +
    (etid ? `&etid=${etid}` : '') +
    (sn ? `&sn=${sn}` : '') +
    (eid ? `&eid=${eid}` : '');

  return axios
    .get<GetReportResponse>(url, {
      signal: controller.signal
    })
    .then(response => {
      if (response.data?.statusOper?.code === 0 && response.data.report) {
        handleDownload(response.data.report, response.data.name, response.data.mime);
      }

      return response;
    })
    .catch(error => {
      throw error;
    });
};
